import { Layout } from "@Components/Layout";
import dynamic from "next/dynamic";
const PrivacyPolicy = dynamic(() =>
  import("@Components/Pages/Pre-Footer/Privacy-Policy")
);
const PrivacyPolicyPage = () => {
  return (
    <Layout>
      <PrivacyPolicy />
    </Layout>
  );
};
export default PrivacyPolicyPage;
